const BENEFICIARY_SUBJECT_TYPE_KEY = 'beneficiary';

export default BENEFICIARY_SUBJECT_TYPE_KEY;
